exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-noResultsWrapper-16bIV{border-top:var(--border);display:grid;place-items:center;height:400px}.style-cssmodule-noResultsContainer-1EGbi{display:flex;flex-direction:column;align-items:center;row-gap:20px;padding:0 20px;max-width:400px}.style-cssmodule-noResultsTitle-2oGlI{color:var(--color-night-gray10,#12223c);text-align:center;font-size:30px;font-style:normal;font-weight:700;line-height:35px;letter-spacing:.3px}.style-cssmodule-noResultsSubtitle-fPYcR{color:var(--color-blue-gray-normal,#9ba7ca);text-align:center;font-size:14px;font-style:normal;font-weight:400;line-height:22px;letter-spacing:.14px}.style-cssmodule-noResultsButton-1lJXE{width:170px}", ""]);

// exports
exports.locals = {
	"noResultsWrapper": "style-cssmodule-noResultsWrapper-16bIV",
	"noResultsContainer": "style-cssmodule-noResultsContainer-1EGbi",
	"noResultsTitle": "style-cssmodule-noResultsTitle-2oGlI",
	"noResultsSubtitle": "style-cssmodule-noResultsSubtitle-fPYcR",
	"noResultsButton": "style-cssmodule-noResultsButton-1lJXE"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/parkings/components/NoResults/style.cssmodule.css
// module id = 2555
// module chunks = 121